<h2 mat-dialog-title>Share your billing details</h2>
<mat-dialog-content class="p-8">

  <div class="flex flex-col w-full py-2 gap-2">
    <div class="w-full">
      <input type="text" id="first_name" [formControl]="name"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        placeholder="Your name (required)" required />
    </div>

    <div class="w-full">
      <input type="text" id="phone_number" [formControl]="phoneNumber"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        placeholder="Phone number (required)" required />
    </div>

    <div class="w-full">
      <input type="text" id="email" type="text" [formControl]="email"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#ff4d06] focus:border-[#ff4d06] block w-full p-2.5 dark:bg-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        placeholder="Email (required)" required />
    </div>

    <div class="flex justify-center items-center">
      <div class="p-4 flex flex-row gap-2 justify-between items-center">
        <button mat-mini-fab color="warn" [disabled]="qty=== 1" (click)="reduce()"
          aria-label="reduce quantity">
          <img src="../../../../assets/graphics/remove_24dp_FILL1_wght400_GRAD0_opsz24.svg" alt="Decrease quantity" />
        </button>
        <input readonly [(ngModel)]="qty"
          class="appearance-none text-center text-lg max-w-24 min-w-24 font-bold block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:border-orange-500"
          id="qty" type="text" min="1" max="10" />
        <button mat-mini-fab color="warn" [disabled]="qty === 10" (click)="increase()"
          aria-label="increase quantity">
          <img src="../../../../assets/graphics/add_24dp_FILL1_wght400_GRAD0_opsz24.svg" alt="Increase quantity" />
        </button>
      </div>



    </div>
  </div>
  <p>Please share your details to place the order successfully</p>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex flex-col gap-4 !w-full">

    <div class="  flex w-full  ">


      <button (click)="confirmOrder()" class="button-82-pushable  w-full flex" [disabled]="!formValid()" role="button">
        <span class="button-82-shadow w-full flex"></span>
        <span class="button-82-edge w-full flex"></span>
        <span class="button-82-front w-full text flex">
          <div class="flex flex-row gap-4 w-full justify-center">
            <span> CONFIRM ORDER</span>

          </div>
        </span>
      </button>


    </div>
    <div class="flex w-full ">
      <button matTooltip="Add to Cart, download the PDF later from the cart" [mat-dialog-close]="true" cdkFocusInitial
        aria-label="add to Cart button" class="button-black-88-pushable  w-full  flex" role="button">
        <span class="button-black-88-shadow w-full flex"></span>
        <span class="button-black-88-edge w-full flex"></span>
        <span class="button-black-88-front w-full text flex">
          <div class="flex flex-row gap-4 w-full justify-center">
            <span> CANCEL </span>

          </div>
        </span>
      </button>
    </div>
  </div>

</mat-dialog-actions>